import chevronRight from './chevron-right.svg';
import circleNotch from './circle-notch.svg';
import paperclip from './paperclip.svg';
export default {
    file: paperclip,
    loader: circleNotch,
    node: chevronRight
};
//# sourceMappingURL=Icons.js.map